<h1 mat-dialog-title>{{data.titulo}}</h1>
<div mat-dialog-content>
    <p class="info-text">{{data.mensagem}}</p>
</div>
<div mat-dialog-actions class="md-toolbar-tools">
    <div class="posicionar-direita">
        <button mat-raised-button type="button" color="primary" mat-dialog-close>Ok</button>
    </div>
</div>
